// Uses translation value instead of regular value

const getTranslationValue = (
  element: string,
  filter: string,
  translations: Array<{ [key: string]: string }>
) => {
  const translation = translations.find(
    (a: { [key: string]: string }) =>
      filter.toLocaleLowerCase() === a.name.toLocaleLowerCase() &&
      a.oldValue.toLocaleLowerCase() === element.toLocaleLowerCase()
  );
  return translation
    ? (translation as { [key: string]: string }).translation
    : element;
};
export default getTranslationValue;
